<template>
  <p class="app-header-title">
    лента: <span class="feed-title">{{threadName}}</span>
  </p>
</template>

<script>
// vuex
import { mapGetters } from "vuex";

export default {
  name: "PageHeader",
  computed: {
    ...mapGetters(["threadName"]),
  }
};
</script>

<style>
.app-header-title {
  padding: 0;
  margin: 0;
  font-family: "Oswald", "Arial", sans-serif;
  font-weight: 300;
  color: #000000;
  font-size: 18px;
  line-height: normal;
  text-transform: uppercase;
}

.feed-title {
  padding-left: 5px;
  font-weight: 500;
}

@media (max-width: 1040px) {
  .app-header-title {
    display: none;
  }
}
</style>
